import { render, staticRenderFns } from "./NotificacoesDia.vue?vue&type=template&id=18cdebfc&scoped=true&"
import script from "./NotificacoesDia.vue?vue&type=script&lang=js&"
export * from "./NotificacoesDia.vue?vue&type=script&lang=js&"
import style0 from "./NotificacoesDia.vue?vue&type=style&index=0&id=18cdebfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cdebfc",
  null
  
)

export default component.exports